declare const __COMMIT_HASH__: string;

import { createFileRoute } from "@tanstack/react-router";
import { useCallback, useLayoutEffect, useState } from "react";
import { useSetAtom } from "jotai";
import { HomeCanvas } from "@/features/home-canvas";
import { useMusic } from "@/lib/hooks/useMusic";
import { MENU_TRACK } from "@/lib/configs/music";
import { setHomeUiReadyAtom } from "@/lib/homeUiAtoms";
import { ReplayTutorialControl } from "@/components/ReplayTutorialControl";
import AudioControl from "@/components/AudioControl";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useTranslation } from "@/lib/hooks/useTranslation";
import type { Locale } from "@/lib/i18n";

export const Route = createFileRoute("/world")({
  component: Home,
});

function Home() {
  const { play } = useMusic();
  const setHomeUiReady = useSetAtom(setHomeUiReadyAtom);
  const [isHomeUiReady, setIsHomeUiReady] = useState(false);
  const { locale, setLocale } = useTranslation();

  // Hide HUD until the splash sequence has been dismissed.
  useLayoutEffect(() => {
    setHomeUiReady(false);
    setIsHomeUiReady(false);

    return () => {
      setHomeUiReady(true);
    };
  }, [setHomeUiReady]);

  const handleSplashDismissed = useCallback(() => {
    setHomeUiReady(true);
    setIsHomeUiReady(true);
    play({ ...MENU_TRACK, autoPlay: true });

    // const hasCompletedOnboarding = localStorage.getItem("onboardingCompleted");

    // const shouldStartHomeModesTour =
    //   hasCompletedOnboarding !== "true" &&
    //   (sessionStorage.getItem("startHomeModesTour") === "true" ||
    //     (localStorage.getItem("cfl:practice-complete-tour-done") === "true" &&
    //       localStorage.getItem("cfl:home-modes-tour-done") !== "true"));

    // if (shouldStartHomeModesTour) {
    //   console.log("[Tour] Starting home modes tour after returning home");
    //   sessionStorage.removeItem("startHomeModesTour");
    //   setTimeout(() => {
    //     requestHomeModesFocus(0)
    //       .catch((error) =>
    //         console.warn("[Tour] Home modes pre-focus failed", error),
    //       )
    //       .finally(() => startNextStep("homeModesTour"));
    //   }, 600);
    //   return;
    // }

    // // Check if user has already completed or skipped the onboarding
    // if (hasCompletedOnboarding === "true") {
    //   console.log("[Tour] Onboarding already completed, skipping tour");
    //   return;
    // }

    // console.log("[Tour] Starting home tour after splash dismissed");
    // startNextStep("homeTour");
  }, [play, setHomeUiReady]);

  const handleLanguageSelect = useCallback(
    (newLocale: Locale) => {
      if (newLocale !== locale) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setLocale(newLocale as any);
        // setLocale will trigger a page refresh
      }
    },
    [locale, setLocale],
  );

  return (
    <div className="relative flex-1 overflow-hidden">
      <HomeCanvas onSplashDismissed={handleSplashDismissed} />
      <div
        className={`fixed bottom-2 left-2 flex items-center gap-1 z-10 transition-opacity duration-300 ease-linear ${
          isHomeUiReady ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <AudioControl />
        <LanguageSwitcher
          value={locale}
          onChange={handleLanguageSelect}
          position="top"
        />
        <ReplayTutorialControl />
      </div>
      <p className="absolute bottom-0 right-2 text-black z-999 pointer-events-none">
        v{__COMMIT_HASH__}
      </p>
    </div>
  );
}
